import { useSuspenseQuery } from '@tanstack/react-query';
import { useCurrentUser } from 'providers/UserProvider';
import type { ApprovalAccess } from 'hooks/useApprovalAccess';
import { featureFlagConfig } from 'hooks/useFeatureFlag';
import { FeatureFlags } from 'utils/featureFlags';
import { ApprovalActionButton } from './ApprovalActionButton';
import { ApprovalButtonVariant, getApprovalButtonVariant } from './approvalButtonVariant';
import { ShareDocumentButtonPopover } from './ShareDocumentButtonPopover.tsx';

interface ApprovalOrShareActionProps {
  contentId: string;
  previewURL: string;
  documentTitleWithCompanyName: string;
  canShare: boolean;
  approvalAccess: ApprovalAccess;
}

export function ApprovalOrShareAction({
  contentId,
  previewURL,
  documentTitleWithCompanyName,
  canShare,
  approvalAccess,
}: ApprovalOrShareActionProps) {
  const { data: currentUser } = useCurrentUser();
  const { data: flags } = useSuspenseQuery(featureFlagConfig(currentUser.id, FeatureFlags.approvalWorkflows));

  const approvalButtonVariant = flags[FeatureFlags.approvalWorkflows]
    ? getApprovalButtonVariant(approvalAccess)
    : ApprovalButtonVariant.SHARE;

  if (approvalButtonVariant === ApprovalButtonVariant.SHARE) {
    return (
      <ShareDocumentButtonPopover
        contentId={contentId}
        previewURL={previewURL}
        documentTitleWithCompanyName={documentTitleWithCompanyName}
        canShare={canShare}
      />
    );
  }

  return (
    <ApprovalActionButton variant={approvalButtonVariant} contentId={contentId} eligibleApprovers={approvalAccess.eligibleApprovers} />
  );
}
